// Katalog kształtów i strzałek
export const SHAPE_CATALOG = {
  shapes: {
    name: "Podstawowe",
    items: {
      square: {
        id: "shape-square",
        name: "Kwadrat",
        dimensions: { width: 60, height: 60 },
        type: "rect",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⬜"
      },
      rectangle: {
        id: "shape-rectangle",
        name: "Prostokąt",
        dimensions: { width: 80, height: 50 },
        type: "rect",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "▭"
      },
      rectDouble: {
        id: "shape-rect-double",
        name: "Prostokąt podwójny",
        dimensions: { width: 80, height: 50 },
        type: "path",
        // Zewnętrzny prostokąt i wewnętrzny prostokąt z offsetem 10
        path: "M-40,-25 L40,-25 L40,25 L-40,25 Z M-30,-15 L30,-15 L30,15 L-30,15 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2, fillRule: "evenodd" },
        thumbnail: "▣"
      },
      circle: {
        id: "shape-circle",
        name: "Koło",
        dimensions: { width: 60, height: 60 },
        type: "circle",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⚪"
      },
      ellipse: {
        id: "shape-ellipse",
        name: "Elipsa",
        dimensions: { width: 80, height: 50 },
        type: "ellipse",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⬭"
      },
      triangle: {
        id: "shape-triangle",
        name: "Trójkąt",
        dimensions: { width: 60, height: 52 },
        type: "path",
        path: "M0,-26 L30,26 L-30,26 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "△"
      },
      rightTriangle: {
        id: "shape-right-triangle",
        name: "Trójkąt prostokątny",
        dimensions: { width: 60, height: 60 },
        type: "path",
        path: "M-30,-30 L30,30 L-30,30 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "📐"
      },
      scalene: {
        id: "shape-scalene",
        name: "Trójkąt różnoboczny",
        dimensions: { width: 60, height: 60 },
        type: "path",
        path: "M-10,-30 L30,30 L-30,30 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⊿"
      },
      rhombus: {
        id: "shape-rhombus",
        name: "Romb",
        dimensions: { width: 60, height: 80 },
        type: "path",
        path: "M0,-40 L30,0 L0,40 L-30,0 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "◇"
      },
      parallelogram: {
        id: "shape-parallelogram",
        name: "Równoległobok",
        dimensions: { width: 80, height: 50 },
        type: "path",
        path: "M-25,-25 L40,-25 L25,25 L-40,25 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "▱"
      },
      trapeze: {
        id: "shape-trapeze",
        name: "Trapez",
        dimensions: { width: 80, height: 50 },
        type: "path",
        path: "M-20,-25 L20,-25 L40,25 L-40,25 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⏢"
      },
      kite: {
        id: "shape-kite",
        name: "Latawiec",
        dimensions: { width: 60, height: 80 },
        type: "path",
        path: "M0,-40 L30,-10 L0,40 L-30,-10 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "🪁"
      },
      pentagon: {
        id: "shape-pentagon",
        name: "Pięciokąt",
        dimensions: { width: 64, height: 60 },
        type: "path",
        // Approx radius 32
        path: "M0,-32 L30.4,-9.9 L18.8,25.9 L-18.8,25.9 L-30.4,-9.9 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⬠"
      },
      hexagon: {
        id: "shape-hexagon",
        name: "Sześciokąt",
        dimensions: { width: 70, height: 60 },
        type: "path",
        // Radius 35
        path: "M17.5,-30.3 L-17.5,-30.3 L-35,0 L-17.5,30.3 L17.5,30.3 L35,0 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⬡"
      },
      octagon: {
        id: "shape-octagon",
        name: "Ośmiokąt",
        dimensions: { width: 60, height: 60 },
        type: "path",
        // Radius 30
        path: "M9,-30 L21,-21 L30,-9 L30,9 L21,21 L9,30 L-9,30 L-21,21 L-30,9 L-30,-9 L-21,-21 L-9,-30 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "🛑"
      },
      polygon: {
        id: "shape-polygon",
        name: "Wielokąt (7-kąt)",
        dimensions: { width: 60, height: 60 },
        type: "path",
        // Heptagon approx
        path: "M0,-30 L23.4,-18.8 L29.2,6.7 L13,27 L-13,27 L-29.2,6.7 L-23.4,-18.8 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "🔷"
      },
      star: {
        id: "shape-star",
        name: "Gwiazda",
        dimensions: { width: 60, height: 58 },
        type: "path",
        path: "M0,-29 L7,-9 L29,-9 L11,5 L18,26 L0,13 L-18,26 L-11,5 L-29,-9 L-7,-9 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⭐"
      },
      heart: {
        id: "shape-heart",
        name: "Serce",
        dimensions: { width: 60, height: 60 },
        type: "path",
        path: "M0,25 C-30,0 -50,-20 -30,-40 C-20,-50 0,-30 0,-30 C0,-30 20,-50 30,-40 C50,-20 30,0 0,25 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "❤️"
      },
      semicircle: {
        id: "shape-semicircle",
        name: "Półkole",
        dimensions: { width: 60, height: 30 },
        type: "path",
        path: "M-30,15 A30,30 0 0,1 30,15 L-30,15 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "🌗"
      },
      crescent: {
        id: "shape-crescent",
        name: "Półksiężyc",
        dimensions: { width: 40, height: 60 },
        type: "path",
        path: "M-10,-25 A30,30 0 0,1 -10,25 A20,20 0 0,0 -10,-25 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "🌙"
      },
      cross: {
        id: "shape-cross",
        name: "Krzyż",
        dimensions: { width: 60, height: 60 },
        type: "path",
        path: "M-10,-30 L10,-30 L10,-10 L30,-10 L30,10 L10,10 L10,30 L-10,30 L-10,10 L-30,10 L-30,-10 L-10,-10 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "✚"
      },
      ring: {
        id: "shape-ring",
        name: "Pierścień",
        dimensions: { width: 60, height: 60 },
        type: "path",
        // Outer 30, Inner 20
        path: "M0,-30 A30,30 0 1,1 0,30 A30,30 0 1,1 0,-30 M0,-20 A20,20 0 1,0 0,20 A20,20 0 1,0 0,-20 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2, fillRule: "evenodd" },
        thumbnail: "⭕"
      },
      pic: {
        id: "shape-pic",
        name: "Ćwierć koła",
        dimensions: { width: 60, height: 60 },
        type: "path",
        path: "M-30,30 L30,30 A60,60 0 0,0 -30,-30 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "🍕"
      },
      quatrefoil: {
        id: "shape-quatrefoil",
        name: "Czterolistna",
        dimensions: { width: 60, height: 60 },
        type: "path",
        // 4 circles
        path: "M0,-10 C10,-10 20,-20 20,-30 C20,-40 10,-50 0,-50 C-10,-50 -20,-40 -20,-30 C-20,-20 -10,-10 0,-10 M30,0 C30,-10 40,-20 50,-20 C60,-20 70,-10 70,0 C70,10 60,20 50,20 C40,20 30,10 30,0 M0,10 C10,10 20,20 20,30 C20,40 10,50 0,50 C-10,50 -20,40 -20,30 C-20,20 -10,10 0,10 M-30,0 C-30,-10 -40,-20 -50,-20 C-60,-20 -70,-10 -70,0 C-70,10 -60,20 -50,20 C-40,20 -30,10 -30,0",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "🍀"
      },
      arrow: {
        id: "shape-arrow-generic",
        name: "Strzałka",
        dimensions: { width: 60, height: 40 },
        type: "path",
        path: "M-20,-10 L10,-10 L10,-20 L30,0 L10,20 L10,10 L-20,10 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "➡️"
      }
    }
  },
  arrows: {
    name: "Strzałki Liniowe",
    items: {
      arrowLeft: {
        id: "arrow-left",
        name: "W lewo",
        dimensions: { width: 100, height: 20 },
        type: "path",
        path: "M-50,0 L-30,-10 L-30,-4 L50,-4 L50,4 L-30,4 L-30,10 Z",
        render: { fill: "#000000", stroke: "#000000", strokeWidth: 1 },
        thumbnail: "⬅️"
      },
      arrowUp: {
        id: "arrow-up",
        name: "W górę",
        dimensions: { width: 20, height: 100 },
        type: "path",
        path: "M0,-50 L10,-30 L4,-30 L4,50 L-4,50 L-4,-30 L-10,-30 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⬆️"
      },
      arrowDown: {
        id: "arrow-down",
        name: "W dół",
        dimensions: { width: 100, height: 20 },
        type: "path",
        path: "M0,50 L10,30 L4,30 L4,-50 L-4,-50 L-4,30 L-10,30 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⬇️"
      },
      arrowNE: {
        id: "arrow-ne",
        name: "Liniowa prosta",
        dimensions: { width: 100, height: 20 },
        type: "path",
        path: "M-40,0 L40,0 M40,0 L28,-10 M40,0 L28,10",
        render: { fill: "none", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "➡️"
      },
      arrowNW: {
        id: "arrow-nw",
        name: "Liniowa dwustronna",
        dimensions: { width: 80, height: 80 },
        type: "path",
        path: "M-40,0 L40,0 M-40,0 L-28,-10 M-40,0 L-28,10 M40,0 L28,-10 M40,0 L28,10",
        render: { fill: "none", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "↔️"
      },
      doubleH: {
        id: "arrow-double-h",
        name: "Dwustronna pełna",
        dimensions: { width: 120, height: 20 },
        type: "path",
        path: "M-60,0 L-45,-10 L-45,-4 L45,-4 L45,-10 L60,0 L45,10 L45,4 L-45,4 L-45,10 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "↔️"
      },
      curveRight: {
        id: "arrow-curve-right",
        name: "Łuk w prawo",
        dimensions: { width: 80, height: 60 },
        type: "path",
        path: "M-35,25 L-25,25 L-25,0 Q-25,-15 0,-15 L15,-15 L15,-5 L35,-20 L15,-35 L15,-25 L0,-25 Q-35,-25 -35,0 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⤵️"
      },
      curveLeft: {
        id: "arrow-curve-left",
        name: "Łuk w lewo",
        dimensions: { width: 80, height: 60 },
        type: "path",
        path: "M35,25 L25,25 L25,0 Q25,-15 0,-15 L-15,-15 L-15,-5 L-35,-20 L-15,-35 L-15,-25 L0,-25 Q35,-25 35,0 Z",
        render: { fill: "#FFFFFF", stroke: "#000000", strokeWidth: 2 },
        thumbnail: "⤴️"
      }
    }
  }
};

export const getShapeById = (id) => {
  for (const category of Object.values(SHAPE_CATALOG)) {
    if (category.items[id]) return category.items[id];
    for (const item of Object.values(category.items)) {
        if (item.id === id) return item;
    }
  }
  return null;
};